import type { ReactNode } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export interface AIChartCardProps {
  title?: string;
  children: ReactNode;
  minHeight?: number;
}

export function AIChartCard({ title, children, minHeight = 320 }: AIChartCardProps) {
  return (
    <div className="ai-viz-zone" style={{ minHeight }} aria-label={title || 'Chart'}>
      {title ? (
        <Text strong style={{ display: 'block', marginBottom: 12 }}>
          {title}
        </Text>
      ) : null}
      {children}
    </div>
  );
}
